export default __webpack_public_path__ + "static/transforming_mobility_thumbnail-7ac7e706814955ae5fcc43ae0b0e03b1.png";